import React , {useEffect, useRef, useState} from "react";
import * as d3 from "d3";
import {areaLabel} from "d3-area-label";
import { BrowserView, MobileView } from "react-device-detect";
import useResizeObserver from "./useResizeObserver";

import FloatingCircles from "./FloatingCircles.js"
import Tooltip from "./Tooltip.js"
import { sliderBottom } from "d3-simple-slider";

function Streamgraph({inputData,stat,iconHoverID}){

    const [yearRange,setYearRange] = useState([1996,2020]);
    const [floatingCirclesData,setFloatingCirclesData] = useState([]);
    const [tooltipEmployerData,setTooltipEmployerData] = useState();
    const [tooltipHighlightYear,setTooltipHighlightYear] = useState();
    const [tooltipSectorData,setTooltipSectorData] = useState();
    const [tooltipHoverColor,setTooltipHoverColor] = useState();
    const [toolPosX,setToolPosX] = useState();
    const [toolPosY,setToolPosY] = useState();

    const svgSliderRef = useRef();
    const svgStreamRef = useRef();
    const wrapperRef = useRef();
    var dimensions = useResizeObserver(wrapperRef);
        
    useEffect(()=>{
        // console.log("streaming")
        const svgStream = d3.select(svgStreamRef.current);
        const svgSlider = d3.select(svgSliderRef.current);
        if (!dimensions) return;
        if (inputData){
            var width = dimensions.width;
            var height = dimensions.height;
            var margin_left = 10;
            var margin_right = 10;
            var margin_top = 10;
            var margin_bottom = 10;

            var yearSlider = sliderBottom()
                .min(1996)
                .max(2020)
                .width(width-2*margin_left-2*margin_right)
                .default([1996,2020])
                // .ticks(6)
                .step(1)
                .tickFormat((d)=>{return d.toLocaleString().replace(/\,/g,'')})
                .displayValue(true)
                .on('end',(val)=>{setYearRange(val)})
            svgSlider.selectAll(".slider-group").data([100]).join("g").attr("class","slider-group").call(yearSlider)

            const sorter = {"University of Toronto":56937,"York University":25046,"University of Waterloo":19730,"University of Ottawa":19613,"Western University":19249,"McMaster University":17971,"Queens University":16151,"Ryerson University":15297,"University of Guelph":13067,"Carleton University":11464,"University of Windsor":8308,"Brock University":8083,"Wilfrid Laurier University":7807,"Seneca College":5545,"Laurentian University":5464,"Humber College":5369,"George Brown College":4417,"Sheridan College":4407,"Lakehead University":4347,"Trent University":3967,"Algonquin College":3907,"Centennial College":3719,"Mohawk College":3542,"Conestoga College":3333,"Fanshawe College":3024,"Durham College":2525,"UOIT":2475,"Georgian College":2434,"Niagara College":2168,"St Clair College":1984,"Nippissing University":1742,"Fleming College":1730,"La Cite College":1449,"St Lawrence College":1418,"Cambrian College":1355,"Kings College":1232,"OCAD":1214,"Northern College":1152,"Confederation College":1103,"Loyalist College":1035,"Lambton College":896,"Canadore College":884,"Sault College":876,"Boreal College":861,"Victoria University":469,"Algoma University":467,"Huron College":420,"Brescia College":329,"Trinity College":217,"St Jeromes University":174,"St Paul University":172,"University of Sudbury":129,"Huntington University":75,"University of Hearst":58,"Thorneloe University":55,"Queens School of Religion":46,"McMaster Divinity College":27,"St Peters Seminary":21,"Universite De LOntario Francais":7,"Wycliffe College":4}
            var keys = [... new Set (inputData.map((eachLine)=>{return eachLine['Employer']}))];
            keys.sort((a,b)=>{return sorter[a.toString()] - sorter[b.toString()]})//would this work?
            var arrayData = [];

            
            for (var year = yearRange[0]; year <=yearRange[1]; year++){
                var yearData = inputData.filter(eachRecord=>(eachRecord['Calendar Year']==year))
                var lineOfArrayData = {"year":year};
                for (var i =0; i<keys.length;i++){
                    var employerYear = yearData.filter(eachPerson=>eachPerson['Employer']==keys[i])

                    if (stat == "Count"){
                        var employerYearStat = employerYear.length
                    }
                    if(stat == "Total"){
                        var employerYearStat = employerYear.map(onePerson=>+onePerson['Salary Paid']).reduce((a,b)=>a+b,0)
                    }
                    else if (stat=="Average"){
                        var employerCount = employerYear.length;
                        var employerTotal = employerYear.map(onePerson=>+onePerson['Salary Paid']).reduce((a,b)=>a+b,0);
                        // console.log(employerCount,employerTotal,Math.round(employerTotal/employerCount))
                        var employerYearStat = employerTotal/employerCount?Math.round(employerTotal/employerCount):0
                    }
                    
                    lineOfArrayData[keys[i]] = employerYearStat
                }
                arrayData.push(lineOfArrayData)
            }
            // console.log(stat,arrayData);
            
            var stackedData = d3.stack().keys(keys)(arrayData)
            // console.log(stackedData)
            if (stackedData[stackedData.length-1]){
                // console.log("calculating axes")
                var maxOfStack = d3.max(stackedData, d => d3.max(d, d=> d[1]))
                var minOfStack = d3.min(stackedData, d => d3.max(d, d=> d[0]))
                var xScale = d3.scaleLinear().domain([yearRange[0],yearRange[1]]).range([3*margin_left,width-margin_right]);                
                var yScale = d3.scaleLinear().domain([minOfStack - 0.1*minOfStack,maxOfStack+0.1*maxOfStack]).range([height-margin_bottom,margin_top]).nice();
                var invertXScale = d3.scaleLinear().domain([margin_left,width-margin_right]).range([yearRange[0],yearRange[1]]);
                // console.log(stackedData)
                var colorScale = d3.scaleLinear().domain([57000,4]).range(["#F88251","#FBE78C"])
                var inverseColorScale = d3.scaleLinear().domain([57000,4]).range(["#FBE78C","#F88251"])
                
                var areaPlot = d3.area()
                .x((d,i)=>{
                    // console.log(d); 
                    return xScale(d.data['year']);
                })
                .y0((d,i)=>{return yScale(d[0]);})
                .y1((d,i)=>{return yScale(d[1]);})
                .curve(d3.curveBasis);

                // console.log(yScale.domain())

                var streamMouseLeave = function(e,i){
                    setTooltipEmployerData()
                    setTooltipHighlightYear()
                    d3.select(this).style("stroke-width","0.5").style("opacity","0.8")
                }

                var streamMouseOver = function(e,i){
                    // console.log("page",e.pageY,"screen",e.screenY,"client",e.clientY,"offset",e.offsetY)
                    // console.log("wh",window.innerHeight,svgStream)
                    var hoverYear = Math.round(invertXScale(e.clientX));
                    var employerData = inputData.filter(eachRecord=>eachRecord['Employer']==i.key);
                    var sectorType = employerData[0]['Sector']
                    // var sectorData = inputData.filter(eachRecord=>eachRecord['Sector']==sectorType)
                    var hoverColor = d3.select(this).style("fill")
                    // console.log(hoverColor)

                    d3.selectAll(".myArea").style("opacity","0.5")
                    d3.select(this).style("stroke-width","0.8").style("opacity","1")
                    
                    var windowWidth = window.innerWidth;
                    var windowHeight= height;
                    var tipWidth;
                    document.querySelector(".tooltip") ? tipWidth = document.querySelector(".tooltip").offsetWidth : tipWidth = 0
                    var tipHeight;
                    document.querySelector(".tooltip") ? tipHeight = document.querySelector(".tooltip").offsetHeight : tipHeight = 0
                    var posX;
                    e.pageX > 0.5*windowWidth ? posX = e.pageX - tipWidth - 20 : posX = e.pageX + 10
                    var posY;
                    e.clientY > 0.3*windowHeight ? posY = e.pageY - tipHeight - 20 : posY = e.pageY + 10
                    // console.log(posX,posY)
                    // var posX = e.pageX;
                    // var posY = e.pageY;

                    setToolPosX(posX)
                    setToolPosY(posY)
                    // setTooltipSectorData(sectorData)
                    setTooltipEmployerData(employerData)
                    setTooltipHighlightYear(hoverYear);
                    setTooltipHoverColor(hoverColor)
                }

                var streamMouseClick = function(e,i){
                    var hoverYear = Math.round(invertXScale(e.clientX));
                    var employerData = inputData.filter(eachRecord=>eachRecord['Employer']==i.key)
                    var employerYearData = employerData.filter(eachPerson=>eachPerson['Calendar Year']==hoverYear)
                    setFloatingCirclesData(employerYearData)
                }
                
                var streamGraph = svgStream.selectAll(".myArea")
                .data(stackedData)
                .join("path")
                .attr("class","myArea")
                .attr("id",(d,i)=>{
                    return "stream_"+d['key'].replace(/[^A-Z0-9]/ig,"_")
                })
                .style("opacity","0.8")
                .attr("d",(d,i)=>{return areaPlot(d)})
                .style("fill",(d,i)=>{return colorScale(sorter[d['key']]);})
                .style("stroke",(d,i)=>{return "white"})
                .style("stroke-width","0.5")
                .on("click",streamMouseClick)
                .on("mouseover",streamMouseOver)
                .on("mousemove",streamMouseOver)
                .on("mouseleave",streamMouseLeave)

                var axisY = d3.axisLeft().scale(yScale).tickSize(width-2*margin_left-2*margin_right)
                if (stat == "Count"){
                    axisY.ticks(4).tickFormat((d)=>{return d.toLocaleString().replace(/\,/g,'')})
                }
                if(stat=="Total"){
                    axisY.ticks(4).tickFormat((d)=>{return d.toLocaleString().replace(/\,000,000$/g,' M').replace(/\,000$/g,' K')})
                }
                else if (stat == "Average"){
                    axisY.ticks(4).tickFormat((d)=>{return d.toLocaleString().replace(/\,000$/g,' K')})
                }
                svgStream.selectAll(".stream-yAxis").data([100]).join("g").call(axisY)
                .attr("class","stream-yAxis")
                .style("transform","translate("+(width-margin_right)+"px"+",0)")

                svgStream.selectAll(".stream-xAxis").data([100]).join("g")
                .call(d3.axisBottom().scale(xScale).tickFormat((d)=>{
                    if (Math.floor(d)!=d){return}
                    else {return d.toLocaleString().replace(/\,/g,'')}
                }))
                .attr("class","stream-xAxis")
                .style("transform","translate(0,"+(height)+"px"+")")

            }
            else{
                svgStream.selectAll("path").remove()
                console.log("i got nothing")
            }
        }
    },[inputData,stat,yearRange,dimensions])

    useEffect(()=>{
        if (iconHoverID){
            d3.selectAll(".myArea").style("opacity","0.5")
            var streamHover = d3.select("#stream_"+iconHoverID.replace(/[^A-Z0-9]/ig,"_"))
            if (streamHover){streamHover.style("opacity","1")}
        }
        else{d3.selectAll(".myArea").style("opacity","0.8")}
    },[iconHoverID])

    return (
        <React.Fragment>
            <BrowserView viewClassName = "streamgraph browserView">
            <div className ="streamgraph-wrapper browser" ref = {wrapperRef}>
                <svg className = "slider browser" ref = {svgSliderRef}></svg>
                <svg className = "streamgraph-svg browser" ref = {svgStreamRef}></svg>
            </div>
            <FloatingCircles yearData = {floatingCirclesData}></FloatingCircles>
            <Tooltip posX = {toolPosX} posY = {toolPosY} employerAllData = {tooltipEmployerData} highlightYear = {tooltipHighlightYear} sectorAllData = {tooltipSectorData} stat={stat} hoverColor = {tooltipHoverColor}></Tooltip>
            </BrowserView>

            <MobileView viewClassName = "streamgraph mobileView">
            <div className ="streamgraph-wrapper mobile" ref = {wrapperRef}>
                <svg className = "slider mobile" ref = {svgSliderRef}></svg>
                <svg className = "streamgraph-svg mobile" ref = {svgStreamRef}></svg>
            </div>
            <FloatingCircles yearData = {floatingCirclesData}></FloatingCircles>
            <Tooltip posX = {toolPosX} posY = {toolPosY} employerAllData = {tooltipEmployerData} highlightYear = {tooltipHighlightYear} sectorAllData = {tooltipSectorData} stat={stat} hoverColor = {tooltipHoverColor}></Tooltip>
            </MobileView>
        </React.Fragment>
    )
}

export default Streamgraph;